import http from "../../http";

export default {
  tongji: (id) => {
    let idStr = id ? "/" + id : "";
    if (idStr) {
      return http.get("activityservice/activityCount/count" + idStr, {});
    }
  },
  data: (param) => {
    return http.post("activityservice/activitycountvto/countvto2", param);
  },
  del: (params) => {
    return http.get("opservice/tenant/update/delete", params);
  },
  activity: (param) => {
    return http.post("activityservice/homestats/activity/overall", param);
  },
  article: (param) => {
    return http.post("opservice/homestats/article/overall", param);
  },
  video: (param) => {
    return http.post("activityservice/homestats/video/overall", param);
  },
  website: (param) => {
    return http.post("opservice/homestats/website/overall", param);
  },
  form: (param) => {
    return http.post("formbuilder/homestats/form/overall", param);
  },
  doc: (param) => {
    return http.post("opservice/homestats/doc/overall", param);
  },
  applyform: (param) => {
    return http.post("formbuilder/homestats/applyform/overall", param);
  },
  clue: (param) => {
    return http.post("formbuilder/homestats/clue/overall", param);
  },
  taskjob: (param) => {
    return http.post("opservice/homestats/taskjob/overall", param);
  },
  dwcompany: (param) => {
    return http.post("opservice/homestats/dwcompany/overall", param);
  },
  user: (param) => {
    return http.post("opservice/homestats/user/overall", param);
  },
  sms: (param) => {
    return http.post("activityservice/activitycountvto/sms/count", param);
  },
  email: (param) => {
    return http.post("activityservice/activitycountvto/mail/count", param);
  },
  enterpriseadmin: (param) => {
    return http.post("opservice/homestats/enterpriseadmin/overall", param);
  },
  pvuv: (param) => {
    return http.post("searchservice/official/website/agges/pvuv", param);
  },
  peek: (param) => {
    return http.post("searchservice/official/website/agges/peek", param);
  },
  top10: (param) => {
    return http.post("searchservice/official/website/agges/top10/rf", param);
  },
  top10Title: (param) => {
    return http.post("searchservice/official/website/agges/top10/title", param);
  },
};
